"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleHeader = exports.SimpleContainer = exports.FilterSection = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FilterSection = _styledComponents["default"].div.withConfig({
  displayName: "FilterSectionstyle__FilterSection",
  componentId: "sc-1dowch1-0"
})(function (props) {
  return (0, _styledComponents.css)(["width:100%;[class*='CollapsibleContainerHeader']{[class*='Pill']{", ";}}", ""], props.theme.mixins.spacing('margin-left', 3), props.isCollapsibleContainerOpen && (0, _styledComponents.css)(["[class*='CollapsibleContainerBody']{overflow:visible;}"]));
});

exports.FilterSection = FilterSection;

var SimpleHeader = _styledComponents["default"].div.withConfig({
  displayName: "FilterSectionstyle__SimpleHeader",
  componentId: "sc-1dowch1-1"
})(function (props) {
  return (0, _styledComponents.css)(["span[class*='Pill']{", ";}font-size:", ";font-weight:", ";display:flex;justify-content:flex-start;flex-grow:1;flex-shrink:1;flex-basis:0;"], props.theme.mixins.spacing('margin-left', 3), props.theme.typography.heading[1].fontDesktop, props.theme.fontWeight[3]);
});

exports.SimpleHeader = SimpleHeader;

var SimpleContainer = _styledComponents["default"].div.withConfig({
  displayName: "FilterSectionstyle__SimpleContainer",
  componentId: "sc-1dowch1-2"
})(function (props) {
  return (0, _styledComponents.css)(["display:block;", ""], props.renderInline && (0, _styledComponents.css)(["display:flex;[class*='Togglestyle']{padding:0;}[class*='ToggleFilter']{padding-bottom:0;}"]));
});

exports.SimpleContainer = SimpleContainer;
//# sourceMappingURL=FilterSection.style.js.map